import { render, staticRenderFns } from "./table-assigned.vue?vue&type=template&id=4fe2f2bc"
import script from "./table-assigned.vue?vue&type=script&lang=js"
export * from "./table-assigned.vue?vue&type=script&lang=js"
import style0 from "./table-assigned.vue?vue&type=style&index=0&id=4fe2f2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports